<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="My Work Status Report"
                :showAddNew="false"
            />
        </div>
        <div class="my-2 px-2">
          <DateQuerySetter
              btnTitle="Go"
              @onClickGo="onClickToGo"
              class="tds-vds-query-setter"
          >
          </DateQuerySetter>
        </div>

      <div class="col-12">
        <div class="d-flex justify-content-end px-2">
          <button
              @click="exportTable"
              class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
          >
            Export
          </button>
        </div>
      </div>

      <div class="col-12 px-2 mt-2 mb-4">
        <div class="card p-2" style="min-height: 200px">
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Work Status Date</th>
                <th>Task Name</th>
                <th>Task Type</th>
                <th>Working Hours</th>
                <th>Task Note</th>
                <th>Work Station</th>
                <th>Conveyance Bill</th>
                <th>Client Name</th>
                <th>Project Name</th>
                <th>Activity / Task Name</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, i) in tableItems" :key="i">
                <td>{{ item.date }}</td>
                <td>{{ item.task_name }}</td>
                <td class="text-capitalize">{{ item.task_type }}</td>
                <td class="text-right">{{ item.hours }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.area_name }}</td>
                <td class="text-right">{{ item.conveyance }}</td>
                <td>{{ item.client_name }}</td>
                <td>{{ item.project_name }}</td>
                <td>{{ item.project_account_name }}</td>
              </tr>
              </tbody>
            </table>
            <p v-if="tableItems.length === 0" class="text-center mt-5">No data</p>
          </div>
        </div>
      </div>
      <div class="px-2 position-absolute bottom-0 mt-4">
        <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
      </div>
     <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleActivity from "@/services/modules/procurement/activity";
import Pagination from '@/components/atom/Pagination'
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const client = ref('');
const contactProfile = ref('');
const loading = ref(false)
const tableItems = ref([]);
const params = ref({
  offset: 20,
});
const token = computed(() => localStorage.getItem('token'));

const { fetchWorkStatusTimeSheet } = handleActivity()

const onClickToGo = () => {
   getTaskManagementList();
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const setPagination = (data) => {
  setPaginationData({
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getTaskManagementList();
}

const getTaskManagementList = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchWorkStatusTimeSheet(query).then(res => {
        if (!res.status){
            return
        }
        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}&route_name=task-calendar&my_timesheet=true`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    query += '&offset=' + params.value.offset
    return query;
}

const exportTable = () => {
  let query = getQuery();
  let url = `${process.env.VUE_APP_BASE_URL}/api/procurement/activity-manager/work-status-timesheet${query}&_token=${token.value}&is_export=1&is_all=1`;
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.click();
};

onMounted(() => {
    Promise.all([
        getTaskManagementList(),
    ])
})

</script>
